import FilterClasses from "react-app/components/planner/menus/FilterClasses"

/** The Ember `Planner::Menus::FilterClasses`, as a React island. */
export default FilterClasses
